import React, { useState, useEffect } from 'react'
import { Box } from '@mui/system'
import { TextField, InputLabel, FormControl, Select, MenuItem, Button } from '@mui/material'
import Sidebar from './sidebar'

import { addDoc, collection, query, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

function Section({ title, accent, bg, children }) {
  return (
    <div style={{ border: "1px solid #e2e2e2", borderRadius: "4px", marginBottom: "16px", overflow: "hidden" }}>
      <div style={{ backgroundColor: bg, borderLeft: `4px solid ${accent}`, padding: "8px 12px", fontWeight: 600 }}>
        {title}
      </div>
      <div style={{ padding: "10px 12px" }}>{children}</div>
    </div>
  );
}

function FieldRow({ label, value, onChange, disabled }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
      <div style={{ width: "45%", fontSize: "13px" }}>{label}</div>
      <div style={{ width: "55%" }}>
        <TextField
          type="number"
          variant="outlined"
          size="small"
          fullWidth
          value={value}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

export default function DailySumbission() {
  const [rows, setRows] = useState([])

  let arr = [];

  useEffect(() => {
    test()
  
    async function test(){
      arr=[]
      getData()
    }

    setRows(arr)
    console.log(arr)
    
  
  
  }, [])
  
  async function getData (){
    let arr = []
    const q = query(collection(db, "staff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }



  const [date, setdate] = useState("");
  const [name, setname] = useState("");
  const [candidates, setcandidates] = useState("")
  const [meals, setmeals] = useState("")
  const [showers, setshowers] = useState("")
  const [male, setmale] = useState("")
  const [female, setfemale] = useState("")
  const [others, setothers] = useState("")
  const [probaition, setprobaition] = useState("")
  const [nonClientFood, setNonClientFood] = useState("")
  const [outreachSupport, setOutreachSupport] = useState("")
  const [tentsIssued, setTentsIssued] = useState("")
  const [homeless, setHomeless] = useState("")
  const [mosesStarter, setMosesStarter] = useState("")
  const [miriamStarter, setMiriamStarter] = useState("")
  const [buddyStarter, setBuddyStarter] = useState("")
  const [mosesFood, setMosesFood] = useState("")
  const [miriamFood, setMiriamFood] = useState("")
  const [buddyFood, setBuddyFood] = useState("")
  const [sleepingBags, setSleepingBags] = useState("")

  const totalAttendees =
    (parseInt(male) || 0) + (parseInt(female) || 0) + (parseInt(others) || 0);

  const pushData = async () => {
    

   
    let main = {

      id: Date.now(),
      date,
      name,
      candidates,
      outreachSupport,
      tentsIssued,
      homeless,
      meals,
      showers,
      mosesStarter,
      miriamStarter,
      buddyStarter,
      mosesFood,
      miriamFood,
      buddyFood,
      male,
      female,
      others,
      probaition,
      nonClientFood,
      sleepingBags

    }
    console.log(main)
    await addDoc(collection(db, "dailySumbissions"), main)
    reset()
  }

  let reset = () =>{
    setcandidates("")
    setdate("")
    setfemale("")
    setmale("")
    setmeals("")
    setname("")
    setothers("")
    setshowers("")
    setprobaition("")
    setNonClientFood("")
    setOutreachSupport("")
    setTentsIssued("")
    setHomeless("")
    setMosesStarter("")
    setMiriamStarter("")
    setBuddyStarter("")
    setMosesFood("")
    setMiriamFood("")
    setBuddyFood("")
    setSleepingBags("")
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />


      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: "50px" }}>

        <div style={{ width: '100%' }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", alignItems: "start" }}>

            <div>
              <div style={{ marginBottom: "16px" }}>
                <TextField type="date" InputLabelProps={{ shrink: true, }} label="Date" variant="outlined" fullWidth onChange={(e) => setdate(e.target.value)} value={date} />
              </div>

              <Section title="Starter Packs" accent="#4a90e2" bg="#dcecfa">
                <FieldRow label="Moses Starter Packs" value={mosesStarter} onChange={setMosesStarter} />
                <FieldRow label="Miriam Starter Packs" value={miriamStarter} onChange={setMiriamStarter} />
                <FieldRow label="Buddy Starter Packs" value={buddyStarter} onChange={setBuddyStarter} />
              </Section>

              <Section title="Food Parcels" accent="#3aa76d" bg="#dff3e6">
                <FieldRow label="Moses Food Parcels" value={mosesFood} onChange={setMosesFood} />
                <FieldRow label="Miriam Food Parcels" value={miriamFood} onChange={setMiriamFood} />
                <FieldRow label="Buddy Food Parcels" value={buddyFood} onChange={setBuddyFood} />
                <FieldRow label="Non-Client Food Parcels" value={nonClientFood} onChange={setNonClientFood} />
              </Section>

              <Section title="Attendee Breakdown" accent="#8e6bd8" bg="#ece5f9">
                <FieldRow label="Male" value={male} onChange={setmale} />
                <FieldRow label="Female" value={female} onChange={setfemale} />
                <FieldRow label="Other Genders" value={others} onChange={setothers} />
                <FieldRow label="Total" value={totalAttendees} disabled />
              </Section>
            </div>

            <div>
              <div style={{ marginBottom: "16px" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Name</InputLabel>
                  <Select
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Name"
                  >
                    {rows.map((v) => {
                      return (
                        <MenuItem value={v.firstName + " " + v.surName}>{v.firstName + " " + v.surName}</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </div>

              <Section title="Attendee Other Information" accent="#e0a63c" bg="#fbf1da">
                <FieldRow label="Outreach Support (None Clients)" value={outreachSupport} onChange={setOutreachSupport} />
                <FieldRow label="Attendees on Probation" value={probaition} onChange={setprobaition} />
                <FieldRow label="Homeless Attendees" value={homeless} onChange={setHomeless} />
              </Section>

              <Section title="Other Support" accent="#e06c8a" bg="#fbe3ea">
                <FieldRow label="Hot Meals Provided" value={meals} onChange={setmeals} />
                <FieldRow label="Showers Provided" value={showers} onChange={setshowers} />
                <FieldRow label="Sleeping Bags" value={sleepingBags} onChange={setSleepingBags} />
                <FieldRow label="Tents Issued" value={tentsIssued} onChange={setTentsIssued} />
              </Section>
            </div>

          </div>

          <Button onClick={pushData} variant="contained" style={{ width: "100%", height: "50px", marginTop: "20px", backgroundColor: "#F21D2F" }}>Submit</Button>
        </div>
      </Box>
    </Box>
  )
}
